export default __webpack_public_path__ + "dd8f7150b4bb9c0b245c27cc9938be8f.coffee";